import { render, staticRenderFns } from "./LastPefDiary.vue?vue&type=template&id=3f6f0b8c&"
import script from "./LastPefDiary.vue?vue&type=script&lang=js&"
export * from "./LastPefDiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports